import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// Components
import Loader from "../../components/common/Loader";
import Menu from "../../components/home1/Menu";
import Navbar from "../../components/home1/Navbar";
import Footer2 from "../../components/home2/Footer";
import Cases from "../../components/home10/Cases";

function Gallery() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("pages.gallery.title")} | One ART</title>

        <link rel="stylesheet" href="/home1/assets/css/home_1_style.css" />
        <link rel="stylesheet" href="/home10/assets/css/home_10_style.css" />
        <link rel="stylesheet" href="/home2/assets/css/home_2_style.css" />

        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
        <script src="/home10/assets/js/home_10_scripts.js" defer></script>
      </Helmet>

      <div className="home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <div style={{ position: 'relative', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
              <img src="/home1/assets/img/slider/head_slide6.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)' }}></div>
            </div>
            <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', color: 'white', padding: '60px 20px' }}>
              <nav aria-label="breadcrumb" style={{ marginBottom: '20px' }}>
                <ol style={{ display: 'flex', justifyContent: 'center', listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginRight: '8px' }}>
                    <a href="/" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>{t('projectPage.breadcrumb.home')}</a>
                  </li>
                  <li style={{ marginRight: '8px', color: 'rgba(255,255,255,0.7)' }}>/</li>
                  <li style={{ color: 'white' }}>{t("pages.gallery.breadcrumb")}</li>
                </ol>
              </nav>
              <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '20px', fontFamily: 'Montserrat, sans-serif' }}>
                {t("pages.gallery.title")}
              </h1>
              <p style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
                {t("pages.gallery.description")}
              </p>
            </div>
          </div>

          <main>
            <Cases />
          </main>

          <Footer2 />
        </div>
      </div>
    </>
  );
}

export default Gallery;
